module.exports = __webpack_public_path__ + "3d3c24115d3866688e95933414a7d125.png";